<template>
    <div
        class="comics-info-container"
        @click="goDetail"
    >
        <div class="comics-image-wrap">
            <img :src="info.cover" alt="">
        </div>
        <div class="comics-info">
            <p class="comics-title">{{ info.title }}</p>
            <div class="tag-list">
                <Tag v-for="tag in info.tags.slice(0,3)" :key="tag.id">
                    {{ sliceStr(tag.name, 5, '..') }}
                </Tag>
            </div>
        </div>
    </div>
</template>

<script>
import { getNovelChapters } from '@/api';
import Tag from '@/components/Tag.vue';
import { debounce, sliceStr } from '@/utils';

export default {
  components: { Tag },
  props: {
    info: {},
  },
  created() {
    this.goDetail = debounce(this.goDetail, 500);
  },
  methods: {
    sliceStr(...args) {
      return sliceStr(...args);
    },
    async goDetail() {
      const { id, first_chapter_id: chapterId } = this.info;
      let res;
      if (!chapterId) {
        res = await getNovelChapters(id);
        if (res.code !== 0) return;
      }
      const { id: cId = '' } = res?.data?.[0] || {};
      this.$router.push(`/novel/${id}/chapter/${chapterId || cId}`);
    },
  },
};
</script>

<style lang="less" scoped>
.comics-info-container {
    display: flex;
    height: 80px;
    margin-bottom: 16px;
    .comics-image-wrap {
        margin-right: 12px;
        width: 142px;
        height: 80px;
        border-radius: 12px;
        overflow: hidden;
    }
    .comics-info {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .comics-title {
        height: 48px;
        line-height: 24px;
        color:@black;
        font-size: @fontLarge;
        .overflow-ellipsis(2);
        }
        .tag-list {
        /deep/ .novel-tag {
            margin-right: 4px;
            max-width: 54px;
        }
        }
    }
}

</style>
